import solid from '@/assets/icons/solid.svg';
import gas from '@/assets/icons/gas.svg';
import liquid from '@/assets/icons/liquid.svg';

export const K0=273.15; //开尔文0度

export const elementsList: any = {
	"H": {
		"cname": "氢",
		"symbol": "H",
		"colors": [
			"#8feaff"
		],
		"number": 1,
		"name": "Hydrogen",
		"MW": 1.00794,
		"CAS": "12385-13-6",
		"period": 1,
		"group": 1,
		"block": "s",
		"AReneg": 2.2,
		"rcov": 0.31,
		"rvdw": 1.1,
		"maxbonds": 1,
		"elneg": 2.2,
		"ionization": 13.5984,
		"elaffinity": 0.75420375,
		"protons": 1,
		"electrons": 1,
		"InChI": "H",
		"InChI_key": "YZCKVEUIGOORGS-UHFFFAOYSA-N",
		"smiles": "[H]",
		"PubChem": 783,
		"phase": "g",
		"Hf": 0,
		"S0": 130.7
	},
	"He": {
		"cname": "氦",
		"symbol": "He",
		"colors": [
			"#c01b1b"
		],
		"number": 2,
		"name": "Helium",
		"MW": 4.002602,
		"CAS": "7440-59-7",
		"period": 1,
		"group": 18,
		"block": "s",
		"AReneg": null,
		"rcov": 0.28,
		"rvdw": 1.4,
		"maxbonds": 0,
		"elneg": null,
		"ionization": 24.5874,
		"elaffinity": null,
		"protons": 2,
		"electrons": 2,
		"InChI": "He",
		"InChI_key": "SWQJXJOGLNCZEY-UHFFFAOYSA-N",
		"smiles": "[He]",
		"PubChem": 23987,
		"phase": "g",
		"Hf": 0,
		"S0": 126.2
	},
	"Li": {
		"cname": "锂",
		"symbol": "Li",
		"colors": [
			"#009E8E"
		],
		"number": 3,
		"name": "Lithium",
		"MW": 6.941,
		"CAS": "7439-93-2",
		"period": 2,
		"group": 1,
		"block": "s",
		"AReneg": 0.97,
		"rcov": 1.28,
		"rvdw": 1.81,
		"maxbonds": 1,
		"elneg": 0.98,
		"ionization": 5.3917,
		"elaffinity": 0.618049,
		"protons": 3,
		"electrons": 3,
		"InChI": "Li",
		"InChI_key": "WHXSMMKQMYFTQS-UHFFFAOYSA-N",
		"smiles": "[Li]",
		"PubChem": 3028194,
		"phase": "s",
		"Hf": 0,
		"S0": 29.1
	},
	"Be": {
		"cname": "铍",
		"symbol": "Be",
		"colors": [
			"#002C6A"
		],
		"number": 4,
		"name": "Beryllium",
		"MW": 9.012182,
		"CAS": "7440-41-7",
		"period": 2,
		"group": 2,
		"block": "s",
		"AReneg": 1.47,
		"rcov": 0.96,
		"rvdw": 1.53,
		"maxbonds": 2,
		"elneg": 1.57,
		"ionization": 9.3227,
		"elaffinity": null,
		"protons": 4,
		"electrons": 4,
		"InChI": "Be",
		"InChI_key": "ATBAMAFKBVZNFJ-UHFFFAOYSA-N",
		"smiles": "[Be]",
		"PubChem": 5460467,
		"phase": "s",
		"Hf": 0,
		"S0": 9.5
	},
	"B": {
		"cname": "硼",
		"symbol": "B",
		"colors": [
			"#998252"
		],
		"number": 5,
		"name": "Boron",
		"MW": 10.811,
		"CAS": "7440-42-8",
		"period": 2,
		"group": 13,
		"block": "p",
		"AReneg": 2.01,
		"rcov": 0.84,
		"rvdw": 1.92,
		"maxbonds": 4,
		"elneg": 2.04,
		"ionization": 8.298,
		"elaffinity": 0.279723,
		"protons": 5,
		"electrons": 5,
		"InChI": "B",
		"InChI_key": "ZOXJGFHDIHLPTG-UHFFFAOYSA-N",
		"smiles": "[B]",
		"PubChem": 5462311,
		"phase": "s",
		"Hf": 0,
		"S0": 5.9
	},
	"C": {
		"cname": "碳",
		"symbol": "C",
		"colors": [
			"#eee"
		],
		"number": 6,
		"name": "Carbon",
		"MW": 12.0107,
		"CAS": "7440-44-0",
		"period": 2,
		"group": 14,
		"block": "p",
		"AReneg": 2.5,
		"rcov": 0.76,
		"rvdw": 1.7,
		"maxbonds": 4,
		"elneg": 2.55,
		"ionization": 11.2603,
		"elaffinity": 1.262118,
		"protons": 6,
		"electrons": 6,
		"InChI": "C",
		"InChI_key": "OKTJSMMVPCPJKN-UHFFFAOYSA-N",
		"smiles": "[C]",
		"PubChem": 5462310,
		"phase": "s",
		"Hf": 0,
		"S0": 5.7
	},
	"N": {
		"cname": "氮",
		"symbol": "N",
		"colors": [
			"#296BEF"
		],
		"number": 7,
		"name": "Nitrogen",
		"MW": 14.0067,
		"CAS": "17778-88-0",
		"period": 2,
		"group": 15,
		"block": "p",
		"AReneg": 3.07,
		"rcov": 0.71,
		"rvdw": 1.55,
		"maxbonds": 4,
		"elneg": 3.04,
		"ionization": 14.5341,
		"elaffinity": -0.07,
		"protons": 7,
		"electrons": 7,
		"InChI": "N",
		"InChI_key": "QJGQUHMNIGDVPM-UHFFFAOYSA-N",
		"smiles": "[N]",
		"PubChem": 222,
		"phase": "g",
		"Hf": 0,
		"S0": 191.6
	},
	"O": {
		"cname": "氧",
		"symbol": "O",
		"colors": [
			"red"
		],
		"number": 8,
		"name": "Oxygen",
		"MW": 15.9994,
		"CAS": "17778-80-2",
		"period": 2,
		"group": 16,
		"block": "p",
		"AReneg": 3.5,
		"rcov": 0.66,
		"rvdw": 1.52,
		"maxbonds": 2,
		"elneg": 3.44,
		"ionization": 13.6181,
		"elaffinity": 1.461112,
		"protons": 8,
		"electrons": 8,
		"InChI": "O",
		"InChI_key": "QVGXLLKOCUKJST-UHFFFAOYSA-N",
		"smiles": "[O]",
		"PubChem": 962,
		"phase": "g",
		"Hf": 0,
		"S0": 205.2
	},
	"F": {
		"cname": "氟",
		"symbol": "F",
		"colors": [
			"#009E8E"
		],
		"number": 9,
		"name": "Fluorine",
		"MW": 18.9984032,
		"CAS": "14762-94-8",
		"period": 2,
		"group": 17,
		"block": "p",
		"AReneg": 4.1,
		"rcov": 0.57,
		"rvdw": 1.47,
		"maxbonds": 1,
		"elneg": 3.98,
		"ionization": 17.4228,
		"elaffinity": 3.4011887,
		"protons": 9,
		"electrons": 9,
		"InChI": "F",
		"InChI_key": "YCKRFDGAMUMZLT-UHFFFAOYSA-N",
		"smiles": "[F]",
		"PubChem": 14917,
		"phase": "g",
		"Hf": 0,
		"S0": 202.8
	},
	"Ne": {
		"cname": "氖",
		"symbol": "Ne",
		"colors": [
			"#E6C37C"
		],
		"number": 10,
		"name": "Neon",
		"MW": 20.1797,
		"CAS": "7440-01-9",
		"period": 2,
		"group": 18,
		"block": "p",
		"AReneg": null,
		"rcov": 0.58,
		"rvdw": 1.54,
		"maxbonds": 0,
		"elneg": null,
		"ionization": 21.5645,
		"elaffinity": null,
		"protons": 10,
		"electrons": 10,
		"InChI": "Ne",
		"InChI_key": "GKAOGPIIYCISHV-UHFFFAOYSA-N",
		"smiles": "[Ne]",
		"PubChem": 23935,
		"phase": "g",
		"Hf": 0,
		"S0": 146.3
	},
	"Na": {
		"cname": "钠",
		"symbol": "Na",
		"colors": [
			"#557BB6"
		],
		"number": 11,
		"name": "Sodium",
		"MW": 22.98977,
		"CAS": "7440-23-5",
		"period": 3,
		"group": 1,
		"block": "s",
		"AReneg": 1.01,
		"rcov": 1.66,
		"rvdw": 2.27,
		"maxbonds": 1,
		"elneg": 0.93,
		"ionization": 5.1391,
		"elaffinity": 0.547926,
		"protons": 11,
		"electrons": 11,
		"InChI": "Na",
		"InChI_key": "KEAYESYHFKHZAL-UHFFFAOYSA-N",
		"smiles": "[Na]",
		"PubChem": 5360545,
		"phase": "s",
		"Hf": 0,
		"S0": 51.3
	},
	"Mg": {
		"cname": "镁",
		"symbol": "Mg",
		"colors": [
			"#C85130"
		],
		"number": 12,
		"name": "Magnesium",
		"MW": 24.305,
		"CAS": "7439-95-4",
		"period": 3,
		"group": 2,
		"block": "s",
		"AReneg": 1.23,
		"rcov": 1.41,
		"rvdw": 1.73,
		"maxbonds": 2,
		"elneg": 1.31,
		"ionization": 7.6462,
		"elaffinity": null,
		"protons": 12,
		"electrons": 12,
		"InChI": "Mg",
		"InChI_key": "FYYHWMGAXLPEAU-UHFFFAOYSA-N",
		"smiles": "[Mg]",
		"PubChem": 5462224,
		"phase": "s",
		"Hf": 0,
		"S0": 32.7
	},
	"Al": {
		"cname": "铝",
		"symbol": "Al",
		"colors": [
			"#344454"
		],
		"number": 13,
		"name": "Aluminium",
		"MW": 26.981538,
		"CAS": "7429-90-5",
		"period": 3,
		"group": 13,
		"block": "p",
		"AReneg": 1.47,
		"rcov": 1.21,
		"rvdw": 1.84,
		"maxbonds": null,
		"elneg": 1.61,
		"ionization": 5.9858,
		"elaffinity": 0.43283,
		"protons": 13,
		"electrons": 13,
		"InChI": "Al",
		"InChI_key": "XAGFODPZIPBFFR-UHFFFAOYSA-N",
		"smiles": "[Al]",
		"PubChem": 5359268,
		"phase": "s",
		"Hf": 0,
		"S0": 28.3
	},
	"Si": {
		"cname": "硅",
		"symbol": "Si",
		"colors": [
			"#AAD2EE"
		],
		"number": 14,
		"name": "Silicon",
		"MW": 28.0855,
		"CAS": "7440-21-3",
		"period": 3,
		"group": 14,
		"block": "p",
		"AReneg": 1.74,
		"rcov": 1.11,
		"rvdw": 2.1,
		"maxbonds": null,
		"elneg": 1.9,
		"ionization": 8.1517,
		"elaffinity": 1.389521,
		"protons": 14,
		"electrons": 14,
		"InChI": "Si",
		"InChI_key": "XUIMIQQOPSSXEZ-UHFFFAOYSA-N",
		"smiles": "[Si]",
		"PubChem": 5461123,
		"phase": "s",
		"Hf": 0,
		"S0": 18.8
	},
	"P": {
		"cname": "磷",
		"symbol": "P",
		"colors": [
			"#007ACC"
		],
		"number": 15,
		"name": "Phosphorus",
		"MW": 30.973761,
		"CAS": "7723-14-0",
		"period": 3,
		"group": 15,
		"block": "p",
		"AReneg": 2.06,
		"rcov": 1.07,
		"rvdw": 1.8,
		"maxbonds": null,
		"elneg": 2.19,
		"ionization": 10.4867,
		"elaffinity": 0.7465,
		"protons": 15,
		"electrons": 15,
		"InChI": "P",
		"InChI_key": "OAICVXFJPJFONN-UHFFFAOYSA-N",
		"smiles": "[P]",
		"PubChem": 24404,
		"phase": "s",
		"Hf": 0,
		"S0": 41.1
	},
	"S": {
		"cname": "硫",
		"symbol": "S",
		"colors": [
			"yellow"
		],
		"number": 16,
		"name": "Sulfur",
		"MW": 32.065,
		"CAS": "7704-34-9",
		"period": 3,
		"group": 16,
		"block": "p",
		"AReneg": 2.44,
		"rcov": 1.05,
		"rvdw": 1.8,
		"maxbonds": null,
		"elneg": 2.58,
		"ionization": 10.36,
		"elaffinity": 2.0771029,
		"protons": 16,
		"electrons": 16,
		"InChI": "S",
		"InChI_key": "NINIDFKCEFEMDL-UHFFFAOYSA-N",
		"smiles": "[S]",
		"PubChem": 402,
		"phase": "s",
		"Hf": 0,
		"S0": 32.1
	},
	"Cl": {
		"cname": "氯",
		"symbol": "Cl",
		"colors": [
			"#FFB5FF"
		],
		"number": 17,
		"name": "Chlorine",
		"MW": 35.453,
		"CAS": "22537-15-1",
		"period": 3,
		"group": 17,
		"block": "p",
		"AReneg": 2.83,
		"rcov": 1.02,
		"rvdw": 1.75,
		"maxbonds": 1,
		"elneg": 3.16,
		"ionization": 12.9676,
		"elaffinity": 3.612724,
		"protons": 17,
		"electrons": 17,
		"InChI": "Cl",
		"InChI_key": "ZAMOUSCENKQFHK-UHFFFAOYSA-N",
		"smiles": "[Cl]",
		"PubChem": 313,
		"phase": "g",
		"Hf": 0,
		"S0": 223.1
	},
	"Ar": {
		"cname": "氩",
		"symbol": "Ar",
		"colors": [
			"#BABABA"
		],
		"number": 18,
		"name": "Argon",
		"MW": 39.948,
		"CAS": "7440-37-1",
		"period": 3,
		"group": 18,
		"block": "p",
		"AReneg": null,
		"rcov": 1.06,
		"rvdw": 1.88,
		"maxbonds": 0,
		"elneg": null,
		"ionization": 15.7596,
		"elaffinity": null,
		"protons": 18,
		"electrons": 18,
		"InChI": "Ar",
		"InChI_key": "XKRFYHLGVUSROY-UHFFFAOYSA-N",
		"smiles": "[Ar]",
		"PubChem": 23968,
		"phase": "g",
		"Hf": 0,
		"S0": 154.8
	},
	"K": {
		"cname": "钾",
		"symbol": "K",
		"colors": [
			"#24FFFB"
		],
		"number": 19,
		"name": "Potassium",
		"MW": 39.0983,
		"CAS": "7440-09-7",
		"period": 4,
		"group": 1,
		"block": "s",
		"AReneg": 0.91,
		"rcov": 2.03,
		"rvdw": 2.75,
		"maxbonds": 1,
		"elneg": 0.82,
		"ionization": 4.3407,
		"elaffinity": 0.501459,
		"protons": 19,
		"electrons": 19,
		"InChI": "K",
		"InChI_key": "ZLMJMSJWJFRBEC-UHFFFAOYSA-N",
		"smiles": "[K]",
		"PubChem": 5462222,
		"phase": "s",
		"Hf": 0,
		"S0": 64.7
	},
	"Ca": {
		"cname": "钙",
		"symbol": "Ca",
		"colors": [
			"#B34BF5"
		],
		"number": 20,
		"name": "Calcium",
		"MW": 40.078,
		"CAS": "7440-70-2",
		"period": 4,
		"group": 2,
		"block": "s",
		"AReneg": 1.04,
		"rcov": 1.76,
		"rvdw": 2.31,
		"maxbonds": 2,
		"elneg": 1,
		"ionization": 6.1132,
		"elaffinity": 0.02455,
		"protons": 20,
		"electrons": 20,
		"InChI": "Ca",
		"InChI_key": "OYPRJOBELJOOCE-UHFFFAOYSA-N",
		"smiles": "[Ca]",
		"PubChem": 5460341,
		"phase": "s",
		"Hf": 0,
		"S0": 41.6
	},
	"Sc": {
		"cname": "钪",
		"symbol": "Sc",
		"colors": [
			"#003556"
		],
		"number": 21,
		"name": "Scandium",
		"MW": 44.95591,
		"CAS": "7440-20-2",
		"period": 4,
		"group": 3,
		"block": "d",
		"AReneg": 1.2,
		"rcov": 1.7,
		"rvdw": 2.3,
		"maxbonds": null,
		"elneg": 1.36,
		"ionization": 6.5615,
		"elaffinity": 0.188,
		"protons": 21,
		"electrons": 21,
		"InChI": "Sc",
		"InChI_key": "SIXSYDAISGFNSX-UHFFFAOYSA-N",
		"smiles": "[Sc]",
		"PubChem": 23952,
		"phase": "s",
		"Hf": 0,
		"S0": 34.6
	},
	"Ti": {
		"cname": "钛",
		"symbol": "Ti",
		"colors": [
			"#00FFFF"
		],
		"number": 22,
		"name": "Titanium",
		"MW": 47.867,
		"CAS": "7440-32-6",
		"period": 4,
		"group": 4,
		"block": "d",
		"AReneg": 1.32,
		"rcov": null,
		"rvdw": 2.15,
		"maxbonds": null,
		"elneg": 1.54,
		"ionization": 6.8281,
		"elaffinity": 0.084,
		"protons": 22,
		"electrons": 22,
		"InChI": "Ti",
		"InChI_key": "RTAQQCXQSZGOHL-UHFFFAOYSA-N",
		"smiles": "[Ti]",
		"PubChem": 23963,
		"phase": "s",
		"Hf": 0,
		"S0": 30.7
	},
	"V": {
		"cname": "钒",
		"symbol": "V",
		"colors": [
			"#8AFFB7"
		],
		"number": 23,
		"name": "Vanadium",
		"MW": 50.9415,
		"CAS": "7440-62-2",
		"period": 4,
		"group": 5,
		"block": "d",
		"AReneg": 1.45,
		"rcov": 1.53,
		"rvdw": 2.05,
		"maxbonds": null,
		"elneg": 1.63,
		"ionization": 6.7462,
		"elaffinity": 0.525,
		"protons": 23,
		"electrons": 23,
		"InChI": "V",
		"InChI_key": "LEONUFNNVUYDNQ-UHFFFAOYSA-N",
		"smiles": "[V]",
		"PubChem": 23990,
		"phase": "s",
		"Hf": 0,
		"S0": 28.9
	},
	"Cr": {
		"cname": "铬",
		"symbol": "Cr",
		"colors": [
			"#4875C6"
		],
		"number": 24,
		"name": "Chromium",
		"MW": 51.9961,
		"CAS": "7440-47-3",
		"period": 4,
		"group": 6,
		"block": "d",
		"AReneg": 1.56,
		"rcov": 1.39,
		"rvdw": 2.05,
		"maxbonds": null,
		"elneg": 1.66,
		"ionization": 6.7665,
		"elaffinity": 0.67584,
		"protons": 24,
		"electrons": 24,
		"InChI": "Cr",
		"InChI_key": "VYZAMTAEIAYCRO-UHFFFAOYSA-N",
		"smiles": "[Cr]",
		"PubChem": 23976,
		"phase": "s",
		"Hf": 0,
		"S0": 23.8
	},
	"Mn": {
		"cname": "锰",
		"symbol": "Mn",
		"colors": [
			"#FDE008"
		],
		"number": 25,
		"name": "Manganese",
		"MW": 54.938049,
		"CAS": "7439-96-5",
		"period": 4,
		"group": 7,
		"block": "d",
		"AReneg": 1.6,
		"rcov": 1.39,
		"rvdw": 2.05,
		"maxbonds": 8,
		"elneg": 1.55,
		"ionization": 7.434,
		"elaffinity": null,
		"protons": 25,
		"electrons": 25,
		"InChI": "Mn",
		"InChI_key": "PWHULOQIROXLJO-UHFFFAOYSA-N",
		"smiles": "[Mn]",
		"PubChem": 23930,
		"phase": "s",
		"Hf": 0,
		"S0": 32
	},
	"Fe": {
		"cname": "铁",
		"symbol": "Fe",
		"colors": [
			"#B7EB8F"
		],
		"number": 26,
		"name": "Iron",
		"MW": 55.845,
		"CAS": "7439-89-6",
		"period": 4,
		"group": 8,
		"block": "d",
		"AReneg": 1.64,
		"rcov": 1.32,
		"rvdw": 2.05,
		"maxbonds": null,
		"elneg": 1.83,
		"ionization": 7.9024,
		"elaffinity": 0.151,
		"protons": 26,
		"electrons": 26,
		"InChI": "Fe",
		"InChI_key": "XEEYBQQBJWHFJM-UHFFFAOYSA-N",
		"smiles": "[Fe]",
		"PubChem": 23925,
		"phase": "s",
		"Hf": 0,
		"S0": 27.3
	},
	"Co": {
		"cname": "钴",
		"symbol": "Co",
		"colors": [
			"#FFD591"
		],
		"number": 27,
		"name": "Cobalt",
		"MW": 58.9332,
		"CAS": "7440-48-4",
		"period": 4,
		"group": 9,
		"block": "d",
		"AReneg": 1.7,
		"rcov": 1.26,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.88,
		"ionization": 7.881,
		"elaffinity": 0.6633,
		"protons": 27,
		"electrons": 27,
		"InChI": "Co",
		"InChI_key": "GUTLYIVDDKVIGB-UHFFFAOYSA-N",
		"smiles": "[Co]",
		"PubChem": 104730,
		"phase": "s",
		"Hf": 0,
		"S0": 30
	},
	"Ni": {
		"cname": "镍",
		"symbol": "Ni",
		"colors": [
			"#91D5FF"
		],
		"number": 28,
		"name": "Nickel",
		"MW": 58.6934,
		"CAS": "7440-02-0",
		"period": 4,
		"group": 10,
		"block": "d",
		"AReneg": 1.75,
		"rcov": 1.24,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.91,
		"ionization": 7.6398,
		"elaffinity": 1.15716,
		"protons": 28,
		"electrons": 28,
		"InChI": "Ni",
		"InChI_key": "PXHVJJICTQNCMI-UHFFFAOYSA-N",
		"smiles": "[Ni]",
		"PubChem": 935,
		"phase": "s",
		"Hf": 0,
		"S0": 29.9
	},
	"Cu": {
		"cname": "铜",
		"symbol": "Cu",
		"colors": [
			"#F6C022"
		],
		"number": 29,
		"name": "Copper",
		"MW": 63.546,
		"CAS": "7440-50-8",
		"period": 4,
		"group": 11,
		"block": "d",
		"AReneg": 1.75,
		"rcov": 1.32,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.9,
		"ionization": 7.7264,
		"elaffinity": 1.23578,
		"protons": 29,
		"electrons": 29,
		"InChI": "Cu",
		"InChI_key": "RYGMFSIKBFXOCR-UHFFFAOYSA-N",
		"smiles": "[Cu]",
		"PubChem": 23978,
		"phase": "s",
		"Hf": 0,
		"S0": 33.2
	},
	"Zn": {
		"cname": "锌",
		"symbol": "Zn",
		"colors": [
			"#419172"
		],
		"number": 30,
		"name": "Zinc",
		"MW": 65.38,
		"CAS": "7440-66-6",
		"period": 4,
		"group": 12,
		"block": "d",
		"AReneg": 1.66,
		"rcov": 1.22,
		"rvdw": 2.1,
		"maxbonds": null,
		"elneg": 1.65,
		"ionization": 9.3942,
		"elaffinity": null,
		"protons": 30,
		"electrons": 30,
		"InChI": "Zn",
		"InChI_key": "HCHKCACWOHOZIP-UHFFFAOYSA-N",
		"smiles": "[Zn]",
		"PubChem": 23994,
		"phase": "s",
		"Hf": 0,
		"S0": 41.6
	},
	"Ga": {
		"cname": "镓",
		"symbol": "Ga",
		"colors": [
			"#B60253"
		],
		"number": 31,
		"name": "Gallium",
		"MW": 69.723,
		"CAS": "7440-55-3",
		"period": 4,
		"group": 13,
		"block": "p",
		"AReneg": 1.82,
		"rcov": 1.22,
		"rvdw": 1.87,
		"maxbonds": 3,
		"elneg": 1.81,
		"ionization": 5.9993,
		"elaffinity": 0.41,
		"protons": 31,
		"electrons": 31,
		"InChI": "Ga",
		"InChI_key": "GYHNNYVSQQEPJS-UHFFFAOYSA-N",
		"smiles": "[Ga]",
		"PubChem": 5360835,
		"phase": "s",
		"Hf": 0,
		"S0": 40.8
	},
	"Ge": {
		"cname": "锗",
		"symbol": "Ge",
		"colors": [
			"#03AAAC"
		],
		"number": 32,
		"name": "Germanium",
		"MW": 72.64,
		"CAS": "7440-56-4",
		"period": 4,
		"group": 14,
		"block": "p",
		"AReneg": 2.02,
		"rcov": 1.2,
		"rvdw": 2.11,
		"maxbonds": 4,
		"elneg": 2.01,
		"ionization": 7.8994,
		"elaffinity": 1.232712,
		"protons": 32,
		"electrons": 32,
		"InChI": "Ge",
		"InChI_key": "GNPVGFCGXDBREM-UHFFFAOYSA-N",
		"smiles": "[Ge]",
		"PubChem": 6326954,
		"phase": "s",
		"Hf": 0,
		"S0": 31.1
	},
	"As": {
		"cname": "砷",
		"symbol": "As",
		"colors": [
			"#7F9DF8"
		],
		"number": 33,
		"name": "Arsenic",
		"MW": 74.9216,
		"CAS": "7440-38-2",
		"period": 4,
		"group": 15,
		"block": "p",
		"AReneg": 2.2,
		"rcov": 1.19,
		"rvdw": 1.85,
		"maxbonds": 3,
		"elneg": 2.18,
		"ionization": 9.7886,
		"elaffinity": 0.814,
		"protons": 33,
		"electrons": 33,
		"InChI": "As",
		"InChI_key": "RQNWIZPPADIBDY-UHFFFAOYSA-N",
		"smiles": "[As]",
		"PubChem": 5359596,
		"phase": "s",
		"Hf": 0,
		"S0": 35.1
	},
	"Se": {
		"cname": "硒",
		"symbol": "Se",
		"colors": [
			"#054397"
		],
		"number": 34,
		"name": "Selenium",
		"MW": 78.96,
		"CAS": "7782-49-2",
		"period": 4,
		"group": 16,
		"block": "p",
		"AReneg": 2.48,
		"rcov": 1.2,
		"rvdw": 1.9,
		"maxbonds": 2,
		"elneg": 2.55,
		"ionization": 9.7524,
		"elaffinity": 2.02067,
		"protons": 34,
		"electrons": 34,
		"InChI": "Se",
		"InChI_key": "BUGBHKTXTAQXES-UHFFFAOYSA-N",
		"smiles": "[Se]",
		"PubChem": 6326970,
		"phase": "s",
		"Hf": 0,
		"S0": 42.4
	},
	"Br": {
		"cname": "溴",
		"symbol": "Br",
		"colors": [
			"#650597"
		],
		"number": 35,
		"name": "Bromine",
		"MW": 79.904,
		"CAS": "10097-32-2",
		"period": 4,
		"group": 17,
		"block": "p",
		"AReneg": 2.74,
		"rcov": 1.2,
		"rvdw": 1.83,
		"maxbonds": 1,
		"elneg": 2.96,
		"ionization": 11.8138,
		"elaffinity": 3.363588,
		"protons": 35,
		"electrons": 35,
		"InChI": "Br",
		"InChI_key": "WKBOTKDWSSQWDR-UHFFFAOYSA-N",
		"smiles": "[Br]",
		"PubChem": 260,
		"phase": "l",
		"Hf": 0,
		"S0": 152.2
	},
	"Kr": {
		"cname": "氪",
		"symbol": "Kr",
		"colors": ["#FADEB6"],
		"number": 36,
		"name": "Krypton",
		"MW": 83.798,
		"CAS": "7439-90-9",
		"period": 4,
		"group": 18,
		"block": "p",
		"AReneg": null,
		"rcov": 1.16,
		"rvdw": 2.02,
		"maxbonds": 0,
		"elneg": 3,
		"ionization": 13.9996,
		"elaffinity": null,
		"protons": 36,
		"electrons": 36,
		"InChI": "Kr",
		"InChI_key": "DNNSSWSSYDEUBZ-UHFFFAOYSA-N",
		"smiles": "[Kr]",
		"PubChem": 5416,
		"phase": "g",
		"Hf": 0,
		"S0": 164.1
	},
	"Rb": {
		"cname": "铷",
		"symbol": "Rb",
		"colors": ["#4A428B"],
		"number": 37,
		"name": "Rubidium",
		"MW": 85.4678,
		"CAS": "7440-17-7",
		"period": 5,
		"group": 1,
		"block": "s",
		"AReneg": 0.89,
		"rcov": 2.2,
		"rvdw": 3.03,
		"maxbonds": 1,
		"elneg": 0.82,
		"ionization": 4.1771,
		"elaffinity": 0.485916,
		"protons": 37,
		"electrons": 37,
		"InChI": "Rb",
		"InChI_key": "IGLNJRXAVVLDKE-UHFFFAOYSA-N",
		"smiles": "[Rb]",
		"PubChem": 5357696,
		"phase": "s",
		"Hf": 0,
		"S0": 76.8
	},
	"Sr": {
		"cname": "锶",
		"symbol": "Sr",
		"colors": ["#314F4F"],
		"number": 38,
		"name": "Strontium",
		"MW": 87.62,
		"CAS": "7440-24-6",
		"period": 5,
		"group": 2,
		"block": "s",
		"AReneg": 0.99,
		"rcov": 1.95,
		"rvdw": 2.49,
		"maxbonds": 2,
		"elneg": 0.95,
		"ionization": 5.6949,
		"elaffinity": 0.05206,
		"protons": 38,
		"electrons": 38,
		"InChI": "Sr",
		"InChI_key": "CIOAGBVUUVVLOB-UHFFFAOYSA-N",
		"smiles": "[Sr]",
		"PubChem": 5359327,
		"phase": "s",
		"Hf": 0,
		"S0": 55
	},
	"Y": {
		"cname": "钇",
		"symbol": "Y",
		"colors": ["#8FBD96"],
		"number": 39,
		"name": "Yttrium",
		"MW": 88.90585,
		"CAS": "7440-65-5",
		"period": 5,
		"group": 3,
		"block": "d",
		"AReneg": 1.11,
		"rcov": 1.9,
		"rvdw": 2.4,
		"maxbonds": null,
		"elneg": 1.22,
		"ionization": 6.2173,
		"elaffinity": 0.307,
		"protons": 39,
		"electrons": 39,
		"InChI": "Y",
		"InChI_key": "VWQVUPCCIRVNHF-UHFFFAOYSA-N",
		"smiles": "[Y]",
		"PubChem": 23993,
		"phase": "s",
		"Hf": 0,
		"S0": 44.4
	},
	"Zr": {
		"cname": "锆",
		"symbol": "Zr",
		"colors": ['#7CFC00'],
		"number": 40,
		"name": "Zirconium",
		"MW": 91.224,
		"CAS": "7440-67-7",
		"period": 5,
		"group": 4,
		"block": "d",
		"AReneg": 1.22,
		"rcov": 1.75,
		"rvdw": 2.3,
		"maxbonds": null,
		"elneg": 1.33,
		"ionization": 6.6339,
		"elaffinity": 0.426,
		"protons": 40,
		"electrons": 40,
		"InChI": "Zr",
		"InChI_key": "QCWXUUIWCKQGHC-UHFFFAOYSA-N",
		"smiles": "[Zr]",
		"PubChem": 23995,
		"phase": "s",
		"Hf": 0,
		"S0": 39
	},
	"Nb": {
		"cname": "铌",
		"symbol": "Nb",
		"colors": ["#04D0D1"],
		"number": 41,
		"name": "Niobium",
		"MW": 92.90638,
		"CAS": "7440-03-1",
		"period": 5,
		"group": 5,
		"block": "d",
		"AReneg": 1.23,
		"rcov": 1.64,
		"rvdw": 2.15,
		"maxbonds": null,
		"elneg": 1.6,
		"ionization": 6.7589,
		"elaffinity": 0.893,
		"protons": 41,
		"electrons": 41,
		"InChI": "Nb",
		"InChI_key": "GUCVJGMIXFAOAE-UHFFFAOYSA-N",
		"smiles": "[Nb]",
		"PubChem": 23936,
		"phase": "s",
		"Hf": 0,
		"S0": 36.4
	},
	"Mo": {
		"cname": "钼",
		"symbol": "Mo",
		"colors": ["#1F90FA"],
		"number": 42,
		"name": "Molybdenum",
		"MW": 95.96,
		"CAS": "7439-98-7",
		"period": 5,
		"group": 6,
		"block": "d",
		"AReneg": 1.3,
		"rcov": 1.54,
		"rvdw": 2.1,
		"maxbonds": null,
		"elneg": 2.16,
		"ionization": 7.0924,
		"elaffinity": 0.7472,
		"protons": 42,
		"electrons": 42,
		"InChI": "Mo",
		"InChI_key": "ZOKXTWBITQBERF-UHFFFAOYSA-N",
		"smiles": "[Mo]",
		"PubChem": 23932,
		"phase": "s",
		"Hf": 0,
		"S0": 28.7
	},
	"Tc": {
		"cname": "锝",
		"symbol": "Tc",
		"colors": ["#661416"],
		"number": 43,
		"name": "Technetium",
		"MW": 98,
		"CAS": "7440-26-8",
		"period": 5,
		"group": 7,
		"block": "d",
		"AReneg": 1.36,
		"rcov": 1.47,
		"rvdw": 2.05,
		"maxbonds": null,
		"elneg": 1.9,
		"ionization": 7.28,
		"elaffinity": 0.55,
		"protons": 43,
		"electrons": 43,
		"InChI": "Tc",
		"InChI_key": "GKLVYJBZJHMRIY-UHFFFAOYSA-N",
		"smiles": "[Tc]",
		"PubChem": 23957,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Ru": {
		"cname": "钌",
		"symbol": "Ru",
		"colors": ["#B52723"],
		"number": 44,
		"name": "Ruthenium",
		"MW": 101.07,
		"CAS": "7440-18-8",
		"period": 5,
		"group": 8,
		"block": "d",
		"AReneg": 1.42,
		"rcov": 1.46,
		"rvdw": 2.05,
		"maxbonds": null,
		"elneg": 2.2,
		"ionization": 7.3605,
		"elaffinity": 1.04638,
		"protons": 44,
		"electrons": 44,
		"InChI": "Ru",
		"InChI_key": "KJTLSVCANCCWHF-UHFFFAOYSA-N",
		"smiles": "[Ru]",
		"PubChem": 23950,
		"phase": "s",
		"Hf": 0,
		"S0": 28.5
	},
	"Rh": {
		"cname": "铑",
		"symbol": "Rh",
		"colors": ["#9A3CC8"],
		"number": 45,
		"name": "Rhodium",
		"MW": 102.9055,
		"CAS": "7440-16-6",
		"period": 5,
		"group": 9,
		"block": "d",
		"AReneg": 1.45,
		"rcov": 1.42,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 2.28,
		"ionization": 7.4589,
		"elaffinity": 1.14289,
		"protons": 45,
		"electrons": 45,
		"InChI": "Rh",
		"InChI_key": "MHOVAHRLVXNVSD-UHFFFAOYSA-N",
		"smiles": "[Rh]",
		"PubChem": 23948,
		"phase": "s",
		"Hf": 0,
		"S0": 31.5
	},
	"Pd": {
		"cname": "钯",
		"symbol": "Pd",
		"colors": ["#DC0A0B"],
		"number": 46,
		"name": "Palladium",
		"MW": 106.42,
		"CAS": "7440-05-3",
		"period": 5,
		"group": 10,
		"block": "d",
		"AReneg": 1.35,
		"rcov": 1.39,
		"rvdw": 2.05,
		"maxbonds": null,
		"elneg": 2.2,
		"ionization": 8.3369,
		"elaffinity": 0.56214,
		"protons": 46,
		"electrons": 46,
		"InChI": "Pd",
		"InChI_key": "KDLHZDBZIXYQEI-UHFFFAOYSA-N",
		"smiles": "[Pd]",
		"PubChem": 23938,
		"phase": "s",
		"Hf": 0,
		"S0": 37.6
	},
	"Ag": {
		"cname": "银",
		"symbol": "Ag",
		"colors": ["#D6DBD5"],
		"number": 47,
		"name": "Silver",
		"MW": 107.8682,
		"CAS": "7440-22-4",
		"period": 5,
		"group": 11,
		"block": "d",
		"AReneg": 1.42,
		"rcov": 1.45,
		"rvdw": 2.1,
		"maxbonds": null,
		"elneg": 1.93,
		"ionization": 7.5762,
		"elaffinity": 1.30447,
		"protons": 47,
		"electrons": 47,
		"InChI": "Ag",
		"InChI_key": "BQCADISMDOOEFD-UHFFFAOYSA-N",
		"smiles": "[Ag]",
		"PubChem": 23954,
		"phase": "s",
		"Hf": 0,
		"S0": 42.6
	},
	"Cd": {
		"cname": "镉",
		"symbol": "Cd",
		"colors": ["#FBE0B5"],
		"number": 48,
		"name": "Cadmium",
		"MW": 112.411,
		"CAS": "7440-43-9",
		"period": 5,
		"group": 12,
		"block": "d",
		"AReneg": 1.46,
		"rcov": 1.44,
		"rvdw": 2.2,
		"maxbonds": null,
		"elneg": 1.69,
		"ionization": 8.9938,
		"elaffinity": null,
		"protons": 48,
		"electrons": 48,
		"InChI": "Cd",
		"InChI_key": "BDOSMKKIYDKNTQ-UHFFFAOYSA-N",
		"smiles": "[Cd]",
		"PubChem": 23973,
		"phase": "s",
		"Hf": 0,
		"S0": 51.8
	},
	"In": {
		"cname": "铟",
		"symbol": "In",
		"colors": ["#AFE3E7"],
		"number": 49,
		"name": "Indium",
		"MW": 114.818,
		"CAS": "7440-74-6",
		"period": 5,
		"group": 13,
		"block": "p",
		"AReneg": 1.49,
		"rcov": 1.42,
		"rvdw": 2.2,
		"maxbonds": 3,
		"elneg": 1.78,
		"ionization": 5.7864,
		"elaffinity": 0.404,
		"protons": 49,
		"electrons": 49,
		"InChI": "In",
		"InChI_key": "APFVFJFRJDLVQX-UHFFFAOYSA-N",
		"smiles": "[In]",
		"PubChem": 5359967,
		"phase": "s",
		"Hf": 0,
		"S0": 57.8
	},
	"Sn": {
		"cname": "锡",
		"symbol": "Sn",
		"colors": ["#E1FFFF"],
		"number": 50,
		"name": "Tin",
		"MW": 118.701,
		"CAS": "7440-31-5",
		"period": 5,
		"group": 14,
		"block": "p",
		"AReneg": 1.72,
		"rcov": 1.39,
		"rvdw": 1.93,
		"maxbonds": 4,
		"elneg": 1.96,
		"ionization": 7.3439,
		"elaffinity": 1.112066,
		"protons": 50,
		"electrons": 50,
		"InChI": "Sn",
		"InChI_key": "ATJFFYVFTNAWJD-UHFFFAOYSA-N",
		"smiles": "[Sn]",
		"PubChem": 5352426,
		"phase": "s",
		"Hf": 0,
		"S0": 51.18
	},
	"Sb": {
		"cname": "锑",
		"symbol": "Sb",
		"colors": ["#2A8724"],
		"number": 51,
		"name": "Antimony",
		"MW": 121.76,
		"CAS": "7440-36-0",
		"period": 5,
		"group": 15,
		"block": "p",
		"AReneg": 1.82,
		"rcov": 1.39,
		"rvdw": 2.17,
		"maxbonds": 3,
		"elneg": 2.05,
		"ionization": 8.6084,
		"elaffinity": 1.047401,
		"protons": 51,
		"electrons": 51,
		"InChI": "Sb",
		"InChI_key": "WATWJIUSRGPENY-UHFFFAOYSA-N",
		"smiles": "[Sb]",
		"PubChem": 5354495,
		"phase": "s",
		"Hf": 0,
		"S0": 45.7
	},
	"Te": {
		"cname": "碲",
		"symbol": "Te",
		"colors": ["#AFFB27"],
		"number": 52,
		"name": "Tellurium",
		"MW": 127.6,
		"CAS": "13494-80-9",
		"period": 5,
		"group": 16,
		"block": "p",
		"AReneg": 2.01,
		"rcov": 1.38,
		"rvdw": 2.06,
		"maxbonds": 2,
		"elneg": 2.1,
		"ionization": 9.0096,
		"elaffinity": 1.970875,
		"protons": 52,
		"electrons": 52,
		"InChI": "Te",
		"InChI_key": "PORWMNRCUJJQNO-UHFFFAOYSA-N",
		"smiles": "[Te]",
		"PubChem": 6327182,
		"phase": "s",
		"Hf": 0,
		"S0": 49.7
	},
	"I": {
		"cname": "碘",
		"symbol": "I",
		"colors": ["#9504D1"],
		"number": 53,
		"name": "Iodine",
		"MW": 126.90447,
		"CAS": "14362-44-8",
		"period": 5,
		"group": 17,
		"block": "p",
		"AReneg": 2.21,
		"rcov": 1.39,
		"rvdw": 1.98,
		"maxbonds": 1,
		"elneg": 2.66,
		"ionization": 10.4513,
		"elaffinity": 3.059038,
		"protons": 53,
		"electrons": 53,
		"InChI": "I",
		"InChI_key": "ZCYVEMRRCGMTRW-UHFFFAOYSA-N",
		"smiles": "[I]",
		"PubChem": 24841,
		"phase": "s",
		"Hf": 0,
		"S0": 116.1
	},
	"Xe": {
		"cname": "氙",
		"symbol": "Xe",
		"colors": ["#FAEED8"],
		"number": 54,
		"name": "Xenon",
		"MW": 131.293,
		"CAS": "7440-63-3",
		"period": 5,
		"group": 18,
		"block": "p",
		"AReneg": null,
		"rcov": 1.4,
		"rvdw": 2.16,
		"maxbonds": 0,
		"elneg": 2.6,
		"ionization": 12.1298,
		"elaffinity": null,
		"protons": 54,
		"electrons": 54,
		"InChI": "Xe",
		"InChI_key": "FHNFHKCVQCLJFQ-UHFFFAOYSA-N",
		"smiles": "[Xe]",
		"PubChem": 23991,
		"phase": "g",
		"Hf": 0,
		"S0": 169.7
	},
	"Cs": {
		"cname": "铯",
		"symbol": "Cs",
		"colors": ["#C17D02"],
		"number": 55,
		"name": "Caesium",
		"MW": 132.90545,
		"CAS": "7440-46-2",
		"period": 6,
		"group": 1,
		"block": "s",
		"AReneg": 0.86,
		"rcov": 2.44,
		"rvdw": 3.43,
		"maxbonds": 1,
		"elneg": 0.79,
		"ionization": 3.8939,
		"elaffinity": 0.471626,
		"protons": 55,
		"electrons": 55,
		"InChI": "Cs",
		"InChI_key": "TVFDJXOCXUVLDH-UHFFFAOYSA-N",
		"smiles": "[Cs]",
		"PubChem": 5354618,
		"phase": "s",
		"Hf": 0,
		"S0": 85.2
	},
	"Ba": {
		"cname": "钡",
		"symbol": "Ba",
		"colors": ["#36C538"],
		"number": 56,
		"name": "Barium",
		"MW": 137.327,
		"CAS": "7440-39-3",
		"period": 6,
		"group": 2,
		"block": "s",
		"AReneg": 0.97,
		"rcov": 2.15,
		"rvdw": 2.68,
		"maxbonds": 2,
		"elneg": 0.89,
		"ionization": 5.2117,
		"elaffinity": 0.14462,
		"protons": 56,
		"electrons": 56,
		"InChI": "Ba",
		"InChI_key": "DSAJWYNOEDNPEQ-UHFFFAOYSA-N",
		"smiles": "[Ba]",
		"PubChem": 5355457,
		"phase": "s",
		"Hf": 0,
		"S0": 62.5
	},
	"La": {
		"cname": "镧",
		"symbol": "La",
		"colors": ["#B0BBD9"],
		"number": 57,
		"name": "Lanthanum",
		"MW": 138.9055,
		"CAS": "7439-91-0",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": 1.08,
		"rcov": 2.07,
		"rvdw": 2.5,
		"maxbonds": 12,
		"elneg": 1.1,
		"ionization": 5.5769,
		"elaffinity": 0.47,
		"protons": 57,
		"electrons": 57,
		"InChI": "La",
		"InChI_key": "FZLIPJUXYLNCLC-UHFFFAOYSA-N",
		"smiles": "[La]",
		"PubChem": 23926,
		"phase": "s",
		"Hf": 0,
		"S0": 56.9
	},
	"Ce": {
		"cname": "铈",
		"symbol": "Ce",
		"colors": ["#FF05FD"],
		"number": 58,
		"name": "Cerium",
		"MW": 140.116,
		"CAS": "7440-45-1",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 2.04,
		"rvdw": 2.48,
		"maxbonds": null,
		"elneg": 1.12,
		"ionization": 5.5387,
		"elaffinity": 0.5,
		"protons": 58,
		"electrons": 58,
		"InChI": "Ce",
		"InChI_key": "GWXLDORMOJMVQZ-UHFFFAOYSA-N",
		"smiles": "[Ce]",
		"PubChem": 23974,
		"phase": "s",
		"Hf": 0,
		"S0": 72
	},
	"Pr": {
		"cname": "镨",
		"symbol": "Pr",
		"colors": ["#29B0A9"],
		"number": 59,
		"name": "Praseodymium",
		"MW": 140.90765,
		"CAS": "7440-10-0",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 2.03,
		"rvdw": 2.47,
		"maxbonds": null,
		"elneg": 1.13,
		"ionization": 5.473,
		"elaffinity": 0.5,
		"protons": 59,
		"electrons": 59,
		"InChI": "Pr",
		"InChI_key": "PUDIUYLPXJFUGB-UHFFFAOYSA-N",
		"smiles": "[Pr]",
		"PubChem": 23942,
		"phase": "s",
		"Hf": 0,
		"S0": 73.2
	},
	"Nd": {
		"cname": "钕",
		"symbol": "Nd",
		"colors": ["#7D8791"],
		"number": 60,
		"name": "Neodymium",
		"MW": 144.24,
		"CAS": "7440-00-8",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 2.01,
		"rvdw": 2.45,
		"maxbonds": null,
		"elneg": 1.14,
		"ionization": 5.525,
		"elaffinity": 0.5,
		"protons": 60,
		"electrons": 60,
		"InChI": "Nd",
		"InChI_key": "QEFYFXOXNSNQGX-UHFFFAOYSA-N",
		"smiles": "[Nd]",
		"PubChem": 23934,
		"phase": "s",
		"Hf": 0,
		"S0": 71.5
	},
	"Pm": {
		"cname": "钷",
		"symbol": "Pm",
		"colors": ["#FF9F77"],
		"number": 61,
		"name": "Promethium",
		"MW": 145,
		"CAS": "7440-12-2",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.99,
		"rvdw": 2.43,
		"maxbonds": null,
		"elneg": null,
		"ionization": 5.582,
		"elaffinity": 0.5,
		"protons": 61,
		"electrons": 61,
		"InChI": "Pm",
		"InChI_key": "VQMWBBYLQSCNPO-UHFFFAOYSA-N",
		"smiles": "[Pm]",
		"PubChem": 23944,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Sm": {
		"cname": "钐",
		"symbol": "Sm",
		"colors": ["#FDBCC4"],
		"number": 62,
		"name": "Samarium",
		"MW": 150.36,
		"CAS": "7440-19-9",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.98,
		"rvdw": 2.42,
		"maxbonds": null,
		"elneg": 1.17,
		"ionization": 5.6437,
		"elaffinity": 0.5,
		"protons": 62,
		"electrons": 62,
		"InChI": "Sm",
		"InChI_key": "KZUNJOHGWZRPMI-UHFFFAOYSA-N",
		"smiles": "[Sm]",
		"PubChem": 23951,
		"phase": "s",
		"Hf": 0,
		"S0": 69.6
	},
	"Eu": {
		"cname": "铕",
		"symbol": "Eu",
		"colors": ["#DFA5D8"],
		"number": 63,
		"name": "Europium",
		"MW": 151.964,
		"CAS": "7440-53-1",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.98,
		"rvdw": 2.4,
		"maxbonds": null,
		"elneg": null,
		"ionization": 5.6704,
		"elaffinity": 0.5,
		"protons": 63,
		"electrons": 63,
		"InChI": "Eu",
		"InChI_key": "OGPBJKLSAFTDLK-UHFFFAOYSA-N",
		"smiles": "[Eu]",
		"PubChem": 23981,
		"phase": "s",
		"Hf": 0,
		"S0": 77.8
	},
	"Gd": {
		"cname": "钆",
		"symbol": "Gd",
		"colors": ["#99F298"],
		"number": 64,
		"name": "Gadolinium",
		"MW": 157.25,
		"CAS": "7440-54-2",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.96,
		"rvdw": 2.38,
		"maxbonds": null,
		"elneg": 1.2,
		"ionization": 6.1498,
		"elaffinity": 0.5,
		"protons": 64,
		"electrons": 64,
		"InChI": "Gd",
		"InChI_key": "UIWYJDYFSGRHKR-UHFFFAOYSA-N",
		"smiles": "[Gd]",
		"PubChem": 23982,
		"phase": "s",
		"Hf": 0,
		"S0": 68.1
	},
	"Tb": {
		"cname": "铽",
		"symbol": "Tb",
		"colors": ["#D16260"],
		"number": 65,
		"name": "Terbium",
		"MW": 158.92534,
		"CAS": "7440-27-9",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.94,
		"rvdw": 2.37,
		"maxbonds": null,
		"elneg": null,
		"ionization": 5.8638,
		"elaffinity": 0.5,
		"protons": 65,
		"electrons": 65,
		"InChI": "Tb",
		"InChI_key": "GZCRRIHWUXGPOV-UHFFFAOYSA-N",
		"smiles": "[Tb]",
		"PubChem": 23958,
		"phase": "s",
		"Hf": 0,
		"S0": 73.2
	},
	"Dy": {
		"cname": "镝",
		"symbol": "Dy",
		"colors": ["#ED967A"],
		"number": 66,
		"name": "Dysprosium",
		"MW": 162.5,
		"CAS": "7429-91-6",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.92,
		"rvdw": 2.35,
		"maxbonds": null,
		"elneg": 1.22,
		"ionization": 5.9389,
		"elaffinity": 0.5,
		"protons": 66,
		"electrons": 66,
		"InChI": "Dy",
		"InChI_key": "KBQHZAAAGSGFKK-UHFFFAOYSA-N",
		"smiles": "[Dy]",
		"PubChem": 23912,
		"phase": "s",
		"Hf": 0,
		"S0": 75.6
	},
	"Ho": {
		"cname": "钬",
		"symbol": "Ho",
		"colors": ["#7C868F"],
		"number": 67,
		"name": "Holmium",
		"MW": 164.93032,
		"CAS": "7440-60-0",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.92,
		"rvdw": 2.33,
		"maxbonds": null,
		"elneg": 1.23,
		"ionization": 6.0215,
		"elaffinity": 0.5,
		"protons": 67,
		"electrons": 67,
		"InChI": "Ho",
		"InChI_key": "KJZYNXUDTRRSPN-UHFFFAOYSA-N",
		"smiles": "[Ho]",
		"PubChem": 23988,
		"phase": "s",
		"Hf": 0,
		"S0": 75.3
	},
	"Er": {
		"cname": "铒",
		"symbol": "Er",
		"colors": ["#94D3E5"],
		"number": 68,
		"name": "Erbium",
		"MW": 167.259,
		"CAS": "7440-52-0",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.89,
		"rvdw": 2.32,
		"maxbonds": null,
		"elneg": 1.24,
		"ionization": 6.1077,
		"elaffinity": 0.5,
		"protons": 68,
		"electrons": 68,
		"InChI": "Er",
		"InChI_key": "UYAHIZSMUZPPFV-UHFFFAOYSA-N",
		"smiles": "[Er]",
		"PubChem": 23980,
		"phase": "s",
		"Hf": 0,
		"S0": 73.2
	},
	"Tm": {
		"cname": "铥",
		"symbol": "Tm",
		"colors": ["#A2522F"],
		"number": 69,
		"name": "Thulium",
		"MW": 168.93421,
		"CAS": "7440-30-4",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.9,
		"rvdw": 2.3,
		"maxbonds": null,
		"elneg": 1.25,
		"ionization": 6.1843,
		"elaffinity": 0.5,
		"protons": 69,
		"electrons": 69,
		"InChI": "Tm",
		"InChI_key": "FRNOGLGSGLTDKL-UHFFFAOYSA-N",
		"smiles": "[Tm]",
		"PubChem": 23961,
		"phase": "s",
		"Hf": 0,
		"S0": 74
	},
	"Yb": {
		"cname": "镱",
		"symbol": "Yb",
		"colors": ["#FA7E74"],
		"number": 70,
		"name": "Ytterbium",
		"MW": 173.054,
		"CAS": "7440-64-4",
		"period": 6,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.87,
		"rvdw": 2.28,
		"maxbonds": null,
		"elneg": null,
		"ionization": 6.2542,
		"elaffinity": 0.5,
		"protons": 70,
		"electrons": 70,
		"InChI": "Yb",
		"InChI_key": "NAWDYIZEMPQZHO-UHFFFAOYSA-N",
		"smiles": "[Yb]",
		"PubChem": 23992,
		"phase": "s",
		"Hf": 0,
		"S0": 59.9
	},
	"Lu": {
		"cname": "镥",
		"symbol": "Lu",
		"colors": ["#3E7D5A"],
		"number": 71,
		"name": "Lutetium",
		"MW": 174.9668,
		"CAS": "7439-94-3",
		"period": 6,
		"group": 3,
		"block": "f",
		"AReneg": null,
		"rcov": 1.87,
		"rvdw": 2.27,
		"maxbonds": null,
		"elneg": 1.27,
		"ionization": 5.4259,
		"elaffinity": 0.5,
		"protons": 71,
		"electrons": 71,
		"InChI": "Lu",
		"InChI_key": "OHSVLFRHMCKCQY-UHFFFAOYSA-N",
		"smiles": "[Lu]",
		"PubChem": 23929,
		"phase": "s",
		"Hf": 0,
		"S0": 51
	},
	"Hf": {
		"cname": "铪",
		"symbol": "Hf",
		"colors": ["#F6A361"],
		"number": 72,
		"name": "Hafnium",
		"MW": 178.49,
		"CAS": "7440-58-6",
		"period": 6,
		"group": 4,
		"block": "d",
		"AReneg": 1.23,
		"rcov": 1.75,
		"rvdw": 2.25,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 6.8251,
		"elaffinity": null,
		"protons": 72,
		"electrons": 72,
		"InChI": "Hf",
		"InChI_key": "VBJZVLUMGGDVMO-UHFFFAOYSA-N",
		"smiles": "[Hf]",
		"PubChem": 23986,
		"phase": "s",
		"Hf": 0,
		"S0": 43.6
	},
	"Ta": {
		"cname": "钽",
		"symbol": "Ta",
		"colors": ["#B1261F"],
		"number": 73,
		"name": "Tantalum",
		"MW": 180.9479,
		"CAS": "7440-25-7",
		"period": 6,
		"group": 5,
		"block": "d",
		"AReneg": 1.33,
		"rcov": 1.7,
		"rvdw": 2.2,
		"maxbonds": null,
		"elneg": 1.5,
		"ionization": 7.5496,
		"elaffinity": 0.322,
		"protons": 73,
		"electrons": 73,
		"InChI": "Ta",
		"InChI_key": "GUVRBAGPIYLISA-UHFFFAOYSA-N",
		"smiles": "[Ta]",
		"PubChem": 23956,
		"phase": "s",
		"Hf": 0,
		"S0": 41.5
	},
	"W": {
		"cname": "钨",
		"symbol": "W",
		"colors": ["#1E3760"],
		"number": 74,
		"name": "Tungsten",
		"MW": 183.84,
		"CAS": "7440-33-7",
		"period": 6,
		"group": 6,
		"block": "d",
		"AReneg": 1.4,
		"rcov": 1.62,
		"rvdw": 2.1,
		"maxbonds": null,
		"elneg": 2.36,
		"ionization": 7.864,
		"elaffinity": 0.815,
		"protons": 74,
		"electrons": 74,
		"InChI": "W",
		"InChI_key": "WFKWXMTUELFFGS-UHFFFAOYSA-N",
		"smiles": "[W]",
		"PubChem": 23964,
		"phase": "s",
		"Hf": 0,
		"S0": 32.6
	},
	"Re": {
		"cname": "铼",
		"symbol": "Re",
		"colors": ["#A25431"],
		"number": 75,
		"name": "Rhenium",
		"MW": 186.207,
		"CAS": "7440-15-5",
		"period": 6,
		"group": 7,
		"block": "d",
		"AReneg": 1.46,
		"rcov": 1.51,
		"rvdw": 2.05,
		"maxbonds": null,
		"elneg": 1.9,
		"ionization": 7.8335,
		"elaffinity": 0.15,
		"protons": 75,
		"electrons": 75,
		"InChI": "Re",
		"InChI_key": "WUAPFZMCVAUBPE-UHFFFAOYSA-N",
		"smiles": "[Re]",
		"PubChem": 23947,
		"phase": "s",
		"Hf": 0,
		"S0": 36.9
	},
	"Os": {
		"cname": "锇",
		"symbol": "Os",
		"colors": ["#4570D9"],
		"number": 76,
		"name": "Osmium",
		"MW": 190.23,
		"CAS": "7440-04-2",
		"period": 6,
		"group": 8,
		"block": "d",
		"AReneg": 1.52,
		"rcov": 1.44,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 2.2,
		"ionization": 8.4382,
		"elaffinity": 1.0778,
		"protons": 76,
		"electrons": 76,
		"InChI": "Os",
		"InChI_key": "SYQBFIAQOQZEGI-UHFFFAOYSA-N",
		"smiles": "[Os]",
		"PubChem": 23937,
		"phase": "s",
		"Hf": 0,
		"S0": 32.6
	},
	"Ir": {
		"cname": "铱",
		"symbol": "Ir",
		"colors": ["#BA918D"],
		"number": 77,
		"name": "Iridium",
		"MW": 192.217,
		"CAS": "7439-88-5",
		"period": 6,
		"group": 9,
		"block": "d",
		"AReneg": 1.55,
		"rcov": 1.41,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 2.2,
		"ionization": 8.967,
		"elaffinity": 1.56436,
		"protons": 77,
		"electrons": 77,
		"InChI": "Ir",
		"InChI_key": "GKOZUEZYRPOHIO-UHFFFAOYSA-N",
		"smiles": "[Ir]",
		"PubChem": 23924,
		"phase": "s",
		"Hf": 0,
		"S0": 35.5
	},
	"Pt": {
		"cname": "铂",
		"symbol": "Pt",
		"colors": ["#E4FDFF"],
		"number": 78,
		"name": "Platinum",
		"MW": 195.078,
		"CAS": "7440-06-4",
		"period": 6,
		"group": 10,
		"block": "d",
		"AReneg": 1.44,
		"rcov": 1.36,
		"rvdw": 2.05,
		"maxbonds": null,
		"elneg": 2.28,
		"ionization": 8.9588,
		"elaffinity": 2.1251,
		"protons": 78,
		"electrons": 78,
		"InChI": "Pt",
		"InChI_key": "BASFCYQUMIYNBI-UHFFFAOYSA-N",
		"smiles": "[Pt]",
		"PubChem": 23939,
		"phase": "s",
		"Hf": 0,
		"S0": 41.6
	},
	"Au": {
		"cname": "金",
		"symbol": "Au",
		"colors": ["#FFA302"],
		"number": 79,
		"name": "Gold",
		"MW": 196.96655,
		"CAS": "7440-57-5",
		"period": 6,
		"group": 11,
		"block": "d",
		"AReneg": 1.42,
		"rcov": 1.36,
		"rvdw": 2.1,
		"maxbonds": null,
		"elneg": 2.54,
		"ionization": 9.2255,
		"elaffinity": 2.30861,
		"protons": 79,
		"electrons": 79,
		"InChI": "Au",
		"InChI_key": "PCHJSUWPFVWCPO-UHFFFAOYSA-N",
		"smiles": "[Au]",
		"PubChem": 23985,
		"phase": "s",
		"Hf": 0,
		"S0": 47.4
	},
	"Hg": {
		"cname": "汞",
		"symbol": "Hg",
		"colors": ["#C2C2C0"],
		"number": 80,
		"name": "Mercury",
		"MW": 200.59,
		"CAS": "7439-97-6",
		"period": 6,
		"group": 12,
		"block": "d",
		"AReneg": 1.44,
		"rcov": 1.32,
		"rvdw": 2.05,
		"maxbonds": null,
		"elneg": 2,
		"ionization": 10.4375,
		"elaffinity": null,
		"protons": 80,
		"electrons": 80,
		"InChI": "Hg",
		"InChI_key": "QSHDDOUJBYECFT-UHFFFAOYSA-N",
		"smiles": "[Hg]",
		"PubChem": 23931,
		"phase": "l",
		"Hf": 0,
		"S0": 75.9
	},
	"Tl": {
		"cname": "铊",
		"symbol": "Tl",
		"colors": ["#860582"],
		"number": 81,
		"name": "Thallium",
		"MW": 204.3833,
		"CAS": "7440-28-0",
		"period": 6,
		"group": 13,
		"block": "p",
		"AReneg": 1.44,
		"rcov": 1.45,
		"rvdw": 1.96,
		"maxbonds": 3,
		"elneg": 1.62,
		"ionization": 6.1082,
		"elaffinity": 0.377,
		"protons": 81,
		"electrons": 81,
		"InChI": "Tl",
		"InChI_key": "BKVIYDNLLOSFOA-UHFFFAOYSA-N",
		"smiles": "[Tl]",
		"PubChem": 5359464,
		"phase": "s",
		"Hf": 0,
		"S0": 64.2
	},
	"Pb": {
		"cname": "铅",
		"symbol": "Pb",
		"colors": ["#2F362E"],
		"number": 82,
		"name": "Lead",
		"MW": 207.2,
		"CAS": "7439-92-1",
		"period": 6,
		"group": 14,
		"block": "p",
		"AReneg": 1.55,
		"rcov": 1.46,
		"rvdw": 2.02,
		"maxbonds": 4,
		"elneg": 2.33,
		"ionization": 7.4167,
		"elaffinity": 0.364,
		"protons": 82,
		"electrons": 82,
		"InChI": "Pb",
		"InChI_key": "WABPQHHGFIMREM-UHFFFAOYSA-N",
		"smiles": "[Pb]",
		"PubChem": 5352425,
		"phase": "s",
		"Hf": 0,
		"S0": 64.8
	},
	"Bi": {
		"cname": "铋",
		"symbol": "Bi",
		"colors": ["#6A8B1E"],
		"number": 83,
		"name": "Bismuth",
		"MW": 208.9804,
		"CAS": "7440-69-9",
		"period": 6,
		"group": 15,
		"block": "p",
		"AReneg": 1.67,
		"rcov": 1.48,
		"rvdw": 2.07,
		"maxbonds": 3,
		"elneg": 2.02,
		"ionization": 7.2855,
		"elaffinity": 0.942363,
		"protons": 83,
		"electrons": 83,
		"InChI": "Bi",
		"InChI_key": "JCXGWMGPZLAOME-UHFFFAOYSA-N",
		"smiles": "[Bi]",
		"PubChem": 5359367,
		"phase": "s",
		"Hf": 0,
		"S0": 56.7
	},
	"Po": {
		"cname": "钋",
		"symbol": "Po",
		"colors": ["#FADEB6"],
		"number": 84,
		"name": "Polonium",
		"MW": 209,
		"CAS": "7440-08-6",
		"period": 6,
		"group": 16,
		"block": "p",
		"AReneg": 1.76,
		"rcov": 1.4,
		"rvdw": 1.97,
		"maxbonds": 2,
		"elneg": 2,
		"ionization": 8.414,
		"elaffinity": 1.9,
		"protons": 84,
		"electrons": 84,
		"InChI": "Po",
		"InChI_key": "HZEBHPIOVYHPMT-UHFFFAOYSA-N",
		"smiles": "[Po]",
		"PubChem": 6328143,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"At": {
		"cname": "砹",
		"symbol": "At",
		"colors": ["#FBEFD9"],
		"number": 85,
		"name": "Astatine",
		"MW": 210,
		"CAS": "7440-68-8",
		"period": 6,
		"group": 17,
		"block": "p",
		"AReneg": 1.9,
		"rcov": 1.5,
		"rvdw": 2.02,
		"maxbonds": 1,
		"elneg": 2.2,
		"ionization": null,
		"elaffinity": 2.8,
		"protons": 85,
		"electrons": 85,
		"InChI": "At",
		"InChI_key": "RYXHOMYVWAEKHL-UHFFFAOYSA-N",
		"smiles": "[At]",
		"PubChem": 5460479,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Rn": {
		"cname": "氡",
		"symbol": "Rn",
		"colors": ["#B2E3E7"],
		"number": 86,
		"name": "Radon",
		"MW": 222,
		"CAS": "10043-92-2",
		"period": 6,
		"group": 18,
		"block": "p",
		"AReneg": null,
		"rcov": 1.5,
		"rvdw": 2.2,
		"maxbonds": 0,
		"elneg": null,
		"ionization": 10.7485,
		"elaffinity": null,
		"protons": 86,
		"electrons": 86,
		"InChI": "Rn",
		"InChI_key": "SYUHGPGVQRZVTB-UHFFFAOYSA-N",
		"smiles": "[Rn]",
		"PubChem": 24857,
		"phase": "g",
		"Hf": 0,
		"S0": 176.2
	},
	"Fr": {
		"cname": "钫",
		"symbol": "Fr",
		"colors": ["#DD7292"],
		"number": 87,
		"name": "Francium",
		"MW": 223,
		"CAS": "7440-73-5",
		"period": 7,
		"group": 1,
		"block": "s",
		"AReneg": null,
		"rcov": 2.6,
		"rvdw": 3.48,
		"maxbonds": 1,
		"elneg": 0.7,
		"ionization": 4.0727,
		"elaffinity": null,
		"protons": 87,
		"electrons": 87,
		"InChI": "Fr",
		"InChI_key": "KLMCZVJOEAUDNE-UHFFFAOYSA-N",
		"smiles": "[Fr]",
		"PubChem": 6328145,
		"phase": "s",
		"Hf": 0,
		"S0": 95.4
	},
	"Ra": {
		"cname": "镭",
		"symbol": "Ra",
		"colors": ["#99F399"],
		"number": 88,
		"name": "Radium",
		"MW": 226,
		"CAS": "7440-14-4",
		"period": 7,
		"group": 2,
		"block": "s",
		"AReneg": null,
		"rcov": 2.21,
		"rvdw": 2.83,
		"maxbonds": 2,
		"elneg": 0.9,
		"ionization": 5.2784,
		"elaffinity": null,
		"protons": 88,
		"electrons": 88,
		"InChI": "Ra",
		"InChI_key": "HCWPIIXVSYCSAN-UHFFFAOYSA-N",
		"smiles": "[Ra]",
		"PubChem": 6328144,
		"phase": "s",
		"Hf": 0,
		"S0": 71
	},
	"Ac": {
		"cname": "锕",
		"symbol": "Ac",
		"colors": ["#A3B4DF"],
		"number": 89,
		"name": "Actinium",
		"MW": 227,
		"CAS": "7440-34-8",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 2.15,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.1,
		"ionization": 5.17,
		"elaffinity": null,
		"protons": 89,
		"electrons": 89,
		"InChI": "Ac",
		"InChI_key": "QQINRWTZWGJFDB-UHFFFAOYSA-N",
		"smiles": "[Ac]",
		"PubChem": 23965,
		"phase": "s",
		"Hf": 0,
		"S0": 56.5
	},
	"Th": {
		"cname": "钍",
		"symbol": "Th",
		"colors": ["#FBE0B5"],
		"number": 90,
		"name": "Thorium",
		"MW": 232.0381,
		"CAS": "7440-29-1",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 2.06,
		"rvdw": 2.4,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 6.3067,
		"elaffinity": null,
		"protons": 90,
		"electrons": 90,
		"InChI": "Th",
		"InChI_key": "ZSLUVFAKFWKJRC-UHFFFAOYSA-N",
		"smiles": "[Th]",
		"PubChem": 23960,
		"phase": "s",
		"Hf": 0,
		"S0": 51.8
	},
	"Pa": {
		"cname": "镤",
		"symbol": "Pa",
		"colors": ["#AD0806"],
		"number": 91,
		"name": "Protactinium",
		"MW": 231.03588,
		"CAS": "7440-13-3",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 2,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.5,
		"ionization": 5.89,
		"elaffinity": null,
		"protons": 91,
		"electrons": 91,
		"InChI": "Pa",
		"InChI_key": "XLROVYAPLOFLNU-UHFFFAOYSA-N",
		"smiles": "[Pa]",
		"PubChem": 23945,
		"phase": "s",
		"Hf": 0,
		"S0": 51.9
	},
	"U": {
		"cname": "铀",
		"symbol": "U",
		"colors": ["#04DDE2"],
		"number": 92,
		"name": "Uranium",
		"MW": 238.02891,
		"CAS": "7440-61-1",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.96,
		"rvdw": 2.3,
		"maxbonds": null,
		"elneg": 1.38,
		"ionization": 6.1941,
		"elaffinity": null,
		"protons": 92,
		"electrons": 92,
		"InChI": "U",
		"InChI_key": "JFALSRSLKYAFGM-UHFFFAOYSA-N",
		"smiles": "[U]",
		"PubChem": 23989,
		"phase": "s",
		"Hf": 0,
		"S0": 50.2
	},
	"Np": {
		"cname": "镎",
		"symbol": "Np",
		"colors": ["#9CCA2A"],
		"number": 93,
		"name": "Neptunium",
		"MW": 237.05,
		"CAS": "7439-99-8",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.9,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.36,
		"ionization": 6.2657,
		"elaffinity": null,
		"protons": 93,
		"electrons": 93,
		"InChI": "Np",
		"InChI_key": "LFNLGNPSGWYGGD-UHFFFAOYSA-N",
		"smiles": "[Np]",
		"PubChem": 23933,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Pu": {
		"cname": "钚",
		"symbol": "Pu",
		"colors": ["#FF6146"],
		"number": 94,
		"name": "Plutonium",
		"MW": 244.06,
		"CAS": "7440-07-5",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.87,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.28,
		"ionization": 6.026,
		"elaffinity": null,
		"protons": 94,
		"electrons": 94,
		"InChI": "Pu",
		"InChI_key": "OYEHPCDNVJXUIW-UHFFFAOYSA-N",
		"smiles": "[Pu]",
		"PubChem": 23940,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Am": {
		"cname": "镅",
		"symbol": "Am",
		"colors": ["#4ADCCD"],
		"number": 95,
		"name": "Americium",
		"MW": 243.06,
		"CAS": "7440-35-9",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.8,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 5.9738,
		"elaffinity": null,
		"protons": 95,
		"electrons": 95,
		"InChI": "Am",
		"InChI_key": "LXQXZNRPTYVCNG-UHFFFAOYSA-N",
		"smiles": "[Am]",
		"PubChem": 23966,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Cm": {
		"cname": "锔",
		"symbol": "Cm",
		"colors": ["#0DF57F"],
		"number": 96,
		"name": "Curium",
		"MW": 247.07,
		"CAS": "7440-51-9",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": 1.69,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 5.9914,
		"elaffinity": null,
		"protons": 96,
		"electrons": 96,
		"InChI": "Cm",
		"InChI_key": "NIWWFAAXEMMFMS-UHFFFAOYSA-N",
		"smiles": "[Cm]",
		"PubChem": 23979,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Bk": {
		"cname": "锫",
		"symbol": "Bk",
		"colors": ["#4D83B1"],
		"number": 97,
		"name": "Berkelium",
		"MW": 247.07,
		"CAS": "7440-40-6",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 6.1979,
		"elaffinity": null,
		"protons": 97,
		"electrons": 97,
		"InChI": "Bk",
		"InChI_key": "PWVKJRSRVJTHTR-UHFFFAOYSA-N",
		"smiles": "[Bk]",
		"PubChem": 23971,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Cf": {
		"cname": "锎",
		"symbol": "Cf",
		"colors": ["#F97D73"],
		"number": 98,
		"name": "Californium",
		"MW": 251.08,
		"CAS": "7440-71-3",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 6.2817,
		"elaffinity": null,
		"protons": 98,
		"electrons": 98,
		"InChI": "Cf",
		"InChI_key": "HGLDOAKPQXAFKI-UHFFFAOYSA-N",
		"smiles": "[Cf]",
		"PubChem": 23997,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Es": {
		"cname": "锿",
		"symbol": "Es",
		"colors": ["#D5B789"],
		"number": 99,
		"name": "Einsteinium",
		"MW": 252.08,
		"CAS": "7429-92-7",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 6.42,
		"elaffinity": null,
		"protons": 99,
		"electrons": 99,
		"InChI": "Es",
		"InChI_key": "CKBRQZNRCSJHFT-UHFFFAOYSA-N",
		"smiles": "[Es]",
		"PubChem": 23913,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Fm": {
		"cname": "镄",
		"symbol": "Fm",
		"colors": ["#D8C1D3"],
		"number": 100,
		"name": "Fermium",
		"MW": 257.1,
		"CAS": "7440-72-4",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 6.5,
		"elaffinity": null,
		"protons": 100,
		"electrons": 100,
		"InChI": "Fm",
		"InChI_key": "MIORUQGGZCBUGO-UHFFFAOYSA-N",
		"smiles": "[Fm]",
		"PubChem": 23998,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Md": {
		"cname": "钔",
		"symbol": "Md",
		"colors": ["#4CDDCE"],
		"number": 101,
		"name": "Mendelevium",
		"MW": 258.1,
		"CAS": "7440-11-1",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 6.58,
		"elaffinity": null,
		"protons": 101,
		"electrons": 101,
		"InChI": "Md",
		"InChI_key": "MQVSLOYRCXQRPM-UHFFFAOYSA-N",
		"smiles": "[Md]",
		"PubChem": 23943,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"No": {
		"cname": "锘",
		"symbol": "No",
		"colors": ["#F38AEF"],
		"number": 102,
		"name": "Nobelium",
		"MW": 259.1,
		"CAS": "10028-14-5",
		"period": 7,
		"group": null,
		"block": "f",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": 1.3,
		"ionization": 6.65,
		"elaffinity": null,
		"protons": 102,
		"electrons": 102,
		"InChI": "No",
		"InChI_key": "ORQBXQOJMQIAOY-UHFFFAOYSA-N",
		"smiles": "[No]",
		"PubChem": 24822,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Lr": {
		"cname": "铹",
		"symbol": "Lr",
		"colors": ["#089201"],
		"number": 103,
		"name": "Lawrencium",
		"MW": 262.11,
		"CAS": "22537-19-5",
		"period": 7,
		"group": 3,
		"block": "f",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": 4.9,
		"elaffinity": null,
		"protons": 103,
		"electrons": 103,
		"InChI": "Lr",
		"InChI_key": "CNQCVBJFEGMYDW-UHFFFAOYSA-N",
		"smiles": "[Lr]",
		"PubChem": 31192,
		"phase": "s",
		"Hf": 0,
		"S0": null
	},
	"Rf": {
		"cname": "𬬻",
		"symbol": "Rf",
		"colors": ["#890684"],
		"number": 104,
		"name": "Rutherfordium",
		"MW": 265.12,
		"CAS": "53850-36-5",
		"period": 7,
		"group": 4,
		"block": "d",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": 6,
		"elaffinity": null,
		"protons": 104,
		"electrons": 104,
		"InChI": "Rf",
		"InChI_key": "YGPLJIIQQIDVFJ-UHFFFAOYSA-N",
		"smiles": "[Rf]",
		"PubChem": 56951715,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Db": {
		"cname": "𬭊",
		"symbol": "Db",
		"colors": ["#A70707"],
		"number": 105,
		"name": "Dubnium",
		"MW": 268.13,
		"CAS": "53850-35-4",
		"period": 7,
		"group": 5,
		"block": "d",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 105,
		"electrons": 105,
		"InChI": "Db",
		"InChI_key": "PUKKTGLVJQVIOF-UHFFFAOYSA-N",
		"smiles": "[Db]",
		"PubChem": 56951718,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Sg": {
		"cname": "𬭳",
		"symbol": "Sg",
		"colors": ["#6D9F9C"],
		"number": 106,
		"name": "Seaborgium",
		"MW": 271.13,
		"CAS": "54038-81-2",
		"period": 7,
		"group": 6,
		"block": "d",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 106,
		"electrons": 106,
		"InChI": "Sg",
		"InChI_key": "VAOUCABZIBBBJH-UHFFFAOYSA-N",
		"smiles": "[Sg]",
		"PubChem": 56951717,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Bh": {
		"cname": "𬭛",
		"symbol": "Bh",
		"colors": ["#D5B789"],
		"number": 107,
		"name": "Bohrium",
		"MW": 270,
		"CAS": "54037-14-8",
		"period": 7,
		"group": 7,
		"block": "d",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 107,
		"electrons": 107,
		"InChI": "Bh",
		"InChI_key": "INOXRQQPOOCQPH-UHFFFAOYSA-N",
		"smiles": "[Bh]",
		"PubChem": 56951713,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Hs": {
		"cname": "𬭶",
		"symbol": "Hs",
		"colors": ["#FA7554"],
		"number": 108,
		"name": "Hassium",
		"MW": 277.15,
		"CAS": "54037-57-9",
		"period": 7,
		"group": 8,
		"block": "d",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 108,
		"electrons": 108,
		"InChI": "Hs",
		"InChI_key": "OBDWMWVOVYJOMI-UHFFFAOYSA-N",
		"smiles": "[Hs]",
		"PubChem": 56951714,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Mt": {
		"cname": "鿏",
		"symbol": "Mt",
		"colors": ["#FFA105"],
		"number": 109,
		"name": "Meitnerium",
		"MW": 276.15,
		"CAS": "54038-01-6",
		"period": 7,
		"group": 9,
		"block": "d",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 109,
		"electrons": 109,
		"InChI": "Mt",
		"InChI_key": "VAJSJTKWMRUWBF-UHFFFAOYSA-N",
		"smiles": "[Mt]",
		"PubChem": 56951716,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Ds": {
		"cname": "𫟼",
		"symbol": "Ds",
		"colors": ["#DA77D1"],
		"number": 110,
		"name": "Darmstadtium",
		"MW": 281.16,
		"CAS": "54083-77-1",
		"period": 7,
		"group": 10,
		"block": "d",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 110,
		"electrons": 110,
		"InChI": "Ds",
		"InChI_key": "NCBMSFCPDGXTHD-UHFFFAOYSA-N",
		"smiles": "[Ds]",
		"PubChem": null,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Rg": {
		"cname": "𬬭",
		"symbol": "Rg",
		"colors": ["#FCBBC3"],
		"number": 111,
		"name": "Roentgenium",
		"MW": 280.16,
		"CAS": "54386-24-2",
		"period": 7,
		"group": 11,
		"block": "d",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 111,
		"electrons": 111,
		"InChI": "Rg",
		"InChI_key": "LJROPTGWFUZRDB-UHFFFAOYSA-N",
		"smiles": "[Rg]",
		"PubChem": null,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Cn": {
		"cname": "鿔",
		"symbol": "Cn",
		"colors": ["#E0A4D7"],
		"number": 112,
		"name": "Copernicium",
		"MW": 285.17,
		"CAS": "54084-26-3",
		"period": 7,
		"group": 12,
		"block": "d",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 112,
		"electrons": 112,
		"InChI": "Cn",
		"InChI_key": "NOTIIDSZELDPOP-UHFFFAOYSA-N",
		"smiles": "[Cn]",
		"PubChem": null,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Nh": {
		"cname": "鉨",
		"symbol": "Nh",
		"colors": ["#C91A85"],
		"number": 113,
		"name": "Nihonium",
		"MW": 284.18,
		"CAS": "54084-70-7",
		"period": 7,
		"group": 13,
		"block": "p",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 113,
		"electrons": 113,
		"InChI": "Nh",
		"InChI_key": "KUGNSLWRKGRKGS-UHFFFAOYSA-N",
		"smiles": "[Nh]",
		"PubChem": null,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Fl": {
		"cname": "鈇",
		"symbol": "Fl",
		"colors": ["#FBEFD9"],
		"number": 114,
		"name": "Flerovium",
		"MW": 289.19,
		"CAS": "54085-16-4",
		"period": 7,
		"group": 14,
		"block": "p",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 114,
		"electrons": 114,
		"InChI": "Fl",
		"InChI_key": "WIHJCBVMYKIGOT-UHFFFAOYSA-N",
		"smiles": "[Fl]",
		"PubChem": null,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Mc": {
		"cname": "镆",
		"symbol": "Mc",
		"colors": ["#DDA51C"],
		"number": 115,
		"name": "Moscovium",
		"MW": 288.19,
		"CAS": "54085-64-2",
		"period": 7,
		"group": 15,
		"block": "p",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 115,
		"electrons": 115,
		"InChI": "Mc",
		"InChI_key": "QDXZEHQJHSHEQF-UHFFFAOYSA-N",
		"smiles": "[Mc]",
		"PubChem": null,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Lv": {
		"cname": "𫟷",
		"symbol": "Lv",
		"colors": ["#FCDFB7"],
		"number": 116,
		"name": "Livermorium",
		"MW": 293,
		"CAS": "54100-71-9",
		"period": 7,
		"group": 16,
		"block": "p",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 116,
		"electrons": 116,
		"InChI": "Lv",
		"InChI_key": "ONFASNXETZOODS-UHFFFAOYSA-N",
		"smiles": "[Lv]",
		"PubChem": null,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Ts": {
		"cname": "石田",
		"symbol": "Ts",
		"colors": ["#1B1E6F"],
		"number": 117,
		"name": "Tennessine",
		"MW": 294,
		"CAS": "54101-14-3",
		"period": 7,
		"group": 17,
		"block": "p",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 117,
		"electrons": 117,
		"InChI": "Ts",
		"InChI_key": "INMSAURDCVBGHH-UHFFFAOYSA-N",
		"smiles": "[Ts]",
		"PubChem": null,
		"phase": "s",
		"Hf": null,
		"S0": null
	},
	"Og": {
		"cname": "气奥",
		"symbol": "Og",
		"colors": ["#A90805"],
		"number": 118,
		"name": "Oganesson",
		"MW": 294,
		"CAS": "54144-19-3",
		"period": 7,
		"group": 18,
		"block": "p",
		"AReneg": null,
		"rcov": null,
		"rvdw": null,
		"maxbonds": null,
		"elneg": null,
		"ionization": null,
		"elaffinity": null,
		"protons": 118,
		"electrons": 118,
		"InChI": "Og",
		"InChI_key": "GOANEQIZDYDFCO-UHFFFAOYSA-N",
		"smiles": "[Og]",
		"PubChem": null,
		"phase": "s",
		"Hf": null,
		"S0": null
	}
}

// 元素字段释义
export const eleProperty: any = {
	'cname': ['元素名称', ''],
	'name': ['英文全称', ''],
	'number': ['原子序数', ''],
	'symbol': ['元素符号', ''],
	'MW': ['原子量', 'g/mol'],
	'protons': ['质子数', ''],
	'electrons': ['电子数', ''],
	'CAS': ['CAS编号', ''],
	'period': ['周期表中的周期', ''],
	'group': ['周期表中的组', ''],
	'block': ['周期表的块', ''],
	'AReneg': ['Allred和Rochow电负性', ''],
	'rcov': ['共价半径', 'Å'],
	'rvdw': ['范德瓦尔斯半径', 'Å'],
	'maxbonds': ['键的最大价', ''],
	'elneg': ['键的最包层电负性大价', ''],
	'ionization': ['电离势', 'eV'],
	'elaffinity': ['亲和力', 'eV'],
	'InChI': ['元素InChI标识符', ''],
	'InChI_key': ['化合物InChI的25字符散列', ''],
	'smiles': ['SMILES编码', ''],
	'PubChem': ['化学品PubChem化合物标识符（CID）', ''],
	'phase': ['atm和298.15K下的标准状态', ''],
	'Hf': ['标准状态下的形成焓', 'J/mol'],
	'S0': ['标准状态下的标准绝对熵（1 bar，298.15 K）', 'J/mol/K'],
}

//金属元素
export const metalElements: any = {
	'钯': 'Pd',
	'铜': 'Cu',
	'铅': 'Pb',
	'银': 'Ag',
	'金': 'Au',
	'镍': 'Ni',
	'铁': 'Fe',
	'钒': 'V',
	'铬': 'Cr',
	'锰': 'Mn',
	'钼': 'Mo',
	'铪': 'Hf',
	'钽': 'Ta',
	'钛': 'Ti',
	'锡': 'Sn',
	'锑': 'Sb',
	'铊': 'Tl',
	'铟': 'In',
	'锗': 'Ge',
	'锆': 'Zr',
	'铝': 'Al',
	'锂': 'Li',
	'镁': 'Mg',
	'钾': 'K',
	'钙': 'Ca',
	'钕': 'Nd',
	'钷': 'Pm',
	'钐': 'Sm',
}

//金属元素
export const metalArr = [
	'Pd',
	'Cu',
	'Pb',
	'Ag',
	'Au',
	'Ni',
	'Fe',
	'V',
	'Cr',
	'Mn',
	'Mo',
	'Hf',
	'Ta',
	'Ti',
	'Sn',
	'Sb',
	'Tl',
	'In',
	'Ge',
	'Zr',
	'Al',
	'Li',
	'Mg',
	'K',
	'Ca',
	'Nd',
	'Pm',
	'Sm',
]

export const metallocene_catalyst_type: any = [
	'非桥连双茂金属',
	'桥连双茂金属',
	'限制几何构型茂金属催化剂'
]

export const groupname: any = [
	'SO3',
	'Dooh',
	'Coov',
	'D2h',
	'C2h',
	'C2v',
	'D2',
	'Cs',
	'Ci',
	'C2',
	'C1',
]


//取代基集合
export const substituents: any = {
	'nonMetal': [
		{
			"name_zh": "甲基",
			"name_en": "Methyl",
			"formula": "CH3",
			"svg": "/qd/img/Methyl.svg",
			"xyz": "/qd/xyz/Methyl.xyz"
		},
		{
			"name_zh": "乙基",
			"name_en": "Ethyl",
			"formula": "C2H5",
			"svg": "/qd/img/Ethyl.svg",
			"xyz": "/qd/xyz/Ethyl.xyz"
		},
		{
			"name_zh": "丙基",
			"name_en": "Propyl",
			"formula": "C3H7",
			"svg": "/qd/img/Propyl.svg",
			"xyz": "/qd/xyz/Propyl.xyz"
		},
		{
			"name_zh": "乙烯基",
			"name_en": "Vinyl",
			"formula": "C2H3",
			"svg": "/qd/img/Vinyl.svg",
			"xyz": "/qd/xyz/Vinyl.xyz"
		},
		{
			"name_zh": "2-丙烯基",
			"name_en": "Allyl",
			"formula": "C3H5",
			"svg": "/qd/img/Allyl.svg",
			"xyz": "/qd/xyz/Allyl.xyz"
		},
		{
			"name_zh": "叔丁基",
			"name_en": "tert-Butyl",
			"formula": "C4H9",
			"svg": "/qd/img/tert-Butyl.svg",
			"xyz": "/qd/xyz/tert-Butyl.xyz"
		},
		{
			"name_zh": "环戊基",
			"name_en": "Cyclopentyl",
			"formula": "C5H9",
			"svg": "/qd/img/Cyclopentyl.svg",
			"xyz": "/qd/xyz/Cyclopentyl.xyz"
		},
		{
			"name_zh": "吡啶基",
			"name_en": "Pyridyl",
			"formula": "C5H4N",
			"svg": "/qd/img/Pyridyl.svg",
			"xyz": "/qd/xyz/Pyridyl.xyz"
		},
		{
			"name_zh": "吡咯基",
			"name_en": "Pyrrolyl",
			"formula": "C4H4N",
			"svg": "/qd/img/Pyrrolyl.svg",
			"xyz": "/qd/xyz/Pyrrolyl.xyz"
		},
		{
			"name_zh": "苯基",
			"name_en": "Phenyl",
			"formula": "C6H5",
			"svg": "/qd/img/Phenyl.svg",
			"xyz": "/qd/xyz/Phenyl.xyz"
		},
		{
			"name_zh": "氢原子",
			"name_en": "Hydrogen Atom",
			"formula": "H",
			"svg": "/qd/img/Hydrogen.svg",
			"xyz": "/qd/xyz/Hydrogen.xyz"
		},
		{
			"name_zh": "氟原子",
			"name_en": "Fluorine Atom",
			"formula": "F",
			"svg": "/qd/img/Fluorine.svg",
			"xyz": "/qd/xyz/Fluorine.xyz"
		},
		{
			"name_zh": "碳原子",
			"name_en": "Carbon Atom",
			"formula": "C",
			"svg": "/qd/img/Carbon.svg",
			"xyz": "/qd/xyz/Carbon.xyz"
		},
		{
			"name_zh": "氮原子",
			"name_en": "Nitrogen Atom",
			"formula": "N",
			"svg": "/qd/img/Nitrogen.svg",
			"xyz": "/qd/xyz/Nitrogen.xyz"
		},
		{
			"name_zh": "氧原子",
			"name_en": "Oxygen Atom",
			"formula": "O",
			"svg": "/qd/img/Oxygen.svg",
			"xyz": "/qd/xyz/Oxygen.xyz"
		},
		{
			"name_zh": "氯原子",
			"name_en": "Chlorine Atom",
			"formula": "Cl",
			"svg": "/qd/img/Chlorine.svg",
			"xyz": "/qd/xyz/Chlorine.xyz"
		},

		{
			"name_zh": "溴原子",
			"name_en": "Bromine Atom",
			"formula": "Br",
			"svg": "/qd/img/Bromine.svg",
			"xyz": "/qd/xyz/Bromine.xyz"
		},
		{
			"name_zh": "碘原子",
			"name_en": "Iodine Atom",
			"formula": "I",
			"svg": "/qd/img/Iodine.svg",
			"xyz": "/qd/xyz/Iodine.xyz"
		}
	],
	'metal': [
		{
			"name_zh": "钙原子",
			"name_en": "Calcium Atom",
			"formula": "Ca",
			"svg": "/qd/img/Calcium.svg",
			"xyz": "/qd/xyz/Calcium.xyz"
		},
		{
			"name_zh": "钛原子",
			"name_en": "Titanium Atom",
			"formula": "Ti",
			"svg": "/qd/img/Titanium.svg",
			"xyz": "/qd/xyz/Titanium.xyz"
		},
		{
			"name_zh": "钒原子",
			"name_en": "Vanadium Atom",
			"formula": "V",
			"svg": "/qd/img/Vanadium.svg",
			"xyz": "/qd/xyz/Vanadium.xyz"
		},
		{
			"name_zh": "铬原子",
			"name_en": "Chromium Atom",
			"formula": "Cr",
			"svg": "/qd/img/Chromium.svg",
			"xyz": "/qd/xyz/Chromium.xyz"
		},
		{
			"name_zh": "锰原子",
			"name_en": "Manganese Atom",
			"formula": "Mn",
			"svg": "/qd/img/Manganese.svg",
			"xyz": "/qd/xyz/Manganese.xyz"
		},
		{
			"name_zh": "铁原子",
			"name_en": "Iron Atom",
			"formula": "Fe",
			"svg": "/qd/img/Iron.svg",
			"xyz": "/qd/xyz/Iron.xyz"
		},
		{
			"name_zh": "钴原子",
			"name_en": "Cobalt Atom",
			"formula": "Co",
			"svg": "/qd/img/Cobalt.svg",
			"xyz": "/qd/xyz/Cobalt.xyz"
		},
		{
			"name_zh": "镍原子",
			"name_en": "Nickel Atom",
			"formula": "Ni",
			"svg": "/qd/img/Nickel.svg",
			"xyz": "/qd/xyz/Nickel.xyz"
		},
		{
			"name_zh": "铜原子",
			"name_en": "Copper Atom",
			"formula": "Cu",
			"svg": "/qd/img/Copper.svg",
			"xyz": "/qd/xyz/Copper.xyz"
		},
	]

}

export const pickModels: any = [
	{
		xyz: '/qdr/01.xyz',
		png: '/qdr/01.png',
	},
	{
		xyz: '/qdr/02.xyz',
		png: '/qdr/02.png',
	},
	{
		xyz: '/qdr/03.xyz',
		png: '/qdr/03.png',
	},
	{
		xyz: '/qdr/04.xyz',
		png: '/qdr/04.png',
	}
]

//温度相关的属性对照
export const props_T: any = {
  Liquid_Thermal_Conductivity: {
    name: "液相导热率",
    unit: "W/mK",
  },
  Gas_Thermal_Conductivity: {
    name: "气相导热率",
    unit: "W/mK",
  },
  Ideal_Gas_Heat_Capacity: {
    name: "理想气体 Cp",
    unit: "J/mol*K",
  },
  Liquid_Heat_Capacity: {
    name: "液体 Cp",
    unit: "J/mol*K",
  },
  Solid_Heat_Capacity: {
    name: "固体 Cp",
    unit: "J/mol*K",
  },
  Heat_of_Vaporization: {
    name: "蒸发焓",
    unit: "J/mol",
  },
  Molar_Liquid_Density: {
    name: "液相摩尔密度",
    unit: "mol/m³",
  },
  Molar_Solid_Density: {
    name: "固相摩尔密度",
    unit: "mol/m³",
  },
  Liquid_Viscosity: {
    name: "液体黏度",
    unit: "Pa*s",
  },
  Gas_Viscosity: {
    name: "气体黏度",
    unit: "Pa*s",
  },
  Saturation_Vapor_Pressure_Gas_Liquid: {
    name: "气‑液饱和压",
    unit: "Pa",
  },
  Saturation_Vapor_Pressure_Gas_Solid: {
    name: "气‑固饱和压",
    unit: "Pa",
  },
  Surface_Tension: {
    name: "表面张力",
    unit: "N/m",
  },
  Solubility_in_Water: {
    name: "水中溶解度",
    unit: "",
  },
}

//标准相态
export const phaseState: any = {
	's': {
		desc: '固态',
		icon:solid
	},
	'l': {
		desc: '液态',
		icon:liquid
	},
	'g': {
		desc: '气态',
		icon:gas
	},
}

// Kabadi-Danner 混合规则中的烃类型编号：非烃=0，烷烃=1，环烷烃=2，烯烃=3，二烯烃=4，芳香烃=5，环烯烃=6，炔烃=7